"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@material-ui/core");
var _templateObject;
var Styled = (0, _styledComponents["default"])(_core.Divider)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n&.divider {\n  width: ", ";\n  height: ", ";\n  align-self: ", ";\n}\n"])), function (props) {
  return props.orientation === 'vertical' ? '1px' : 'auto';
}, function (props) {
  return props.orientation === 'vertical' ? 'auto' : '1px';
}, function (props) {
  return props.orientation === 'vertical' ? 'stretch' : 'auto';
});
exports.Styled = Styled;